import { ProcessDeUtil } from '../../domain/process-de-util';
import { WfLocalePipe } from '../../i18n/pipe/wf-process-editor-locale.pipe';
import { SmsMessageTemplate } from '../sms-message-template/sms-message-template';

export class TimeLimitInfo {
    tag: string;

    /**
     * 是否启用
     */
    enable: boolean;

    /**
     * 限定时长
     */
    dueTime: string;

    /**
     * 时间单位
     */
    timeUnit: string;

    expireOperations: Array<ExpireOperation>;

    constructor() {
        this.tag = 'constant';
        this.enable = false;
        this.timeUnit = 'day';
        this.expireOperations = new Array();
    }
}

export class ExpireOperation {
    id: string;
    /**
     * 期限控制类型
     */
    durationType: string;

    /**
     * 任务期限
     */
    timeDuration: number;

    /**
     * 时间单位
     */
    timeUnit: string;

    /**
     * 操作类型名称
     */
    operationTypeName: string;

    constructor() {
        this.id = ProcessDeUtil.GenerateElementId();
        this.durationType = 'BeforeDuration';
        this.timeDuration = 0;
        this.timeUnit = 'day';
        // 默认操作类型是发送预警消息
        this.operationTypeName = 'SendMessageExpireOperation';
    }
}

/**
 * 发送预警信息方式
 */
export class SendMessage extends ExpireOperation{
    /**
     * 预警信息内容
     */
    message: string;

    /**
     * 发送预警信息类型
     */
    sendType: string;

    /**
     * 预警信息主题
     */
    subject: string;

    /**
     * 消息接收人
     * 用户IDs
     */
    receiver?: string;

    /**
     * 消息接收人显示
     */
    receiverText?: string;

    /**
     * 启用循环预警
     */
    cycleEnable: boolean;

    /**
     * 循环预警时间间隔
     */
    cycleTime: string;

    /**
     * 循环预警时间间隔单位
     */
    cycleTimeUnit: string;

    /**
     * 短信模板
     */
    smsMessageTemplate: SmsMessageTemplate

    constructor(
      location,
      private localePipe: WfLocalePipe
      ) {
      super();
      this.cycleEnable = false;
      this.cycleTimeUnit = 'day';
      this.receiver = location === 'activity' ? 'workItemParticipant' : 'procInstCreator';
      this.receiverText = location === 'activity' ? this.localePipe.transform('component.timeLimitControl.workItemParticipant') : this.localePipe.transform('component.timeLimitControl.procInstCreator');
      this.subject = `{"expr":"\'` + this.localePipe.transform('component.timeLimitControl.SendMessageExpireOperation') + `\'","sexpr":""}`;
      this.message = `{"expr":"\'` + (location === 'activity' ?  this.localePipe.transform('component.timeLimitControl.to-doMessageTimeOut') :  this.localePipe.transform('component.timeLimitControl.messageTimeOut')) + `\'","sexpr":""}`;
    }
}

export class AutoHandle extends ExpireOperation {
  /**
   * 办理类型，通过驳回否决等等
   */
  autoHandleType: string;

  /**
   * 办理意见
   */
  message: string;

  constructor(
    type: string,
    private localePipe: WfLocalePipe
  ) {
    super();
    this.autoHandleType = type;
    this.message = this.localePipe.transform('component.timeLimitControl.agree');
  }
}
